import {
  ClientCategoryIndicatorsOverview,
  ServerAnalysisItem,
  ServerCategorizationsData,
} from "../models/data-structures";
import { IndicatorOverviewsInnerCardProps } from "../components/IndicatorOverviewsInnerCard";
import { getVerdictByRating } from "./business-rules";
import { ObjectOverviewsProps } from "../components/ObjectViewLayoutCard";

export function extractObjectOverviewCardsPropsFromServerData(
  serverData: ServerCategorizationsData
): ObjectOverviewsProps[] {
  let objects: ServerAnalysisItem[] = [];

  for (let serverAnalysisItem of serverData.Objects|| []) {
    serverAnalysisItem.IndicatorCategories =
      serverAnalysisItem.IndicatorCategories.sort(
        (c1, c2) =>
          Math.max(...c2.Indicators.map((ind) => ind.Rating)) -
          Math.max(...c1.Indicators.map((ind) => ind.Rating))
      );
    objects.push(serverAnalysisItem);
  }

  return objects;
}

export function extractOverviewCardsPropsFromServerData(
  serverData: ServerCategorizationsData
): IndicatorOverviewsInnerCardProps[] {
  let accumulatedCategoryOverviews: {
    [category: string]: ClientCategoryIndicatorsOverview;
  } = {};

  // Method builds the categories by looping through server data and creating category if not already created
  for (let serverAnalysisItem of serverData.Objects || []) {
    for (let indicatorCategory of serverAnalysisItem.IndicatorCategories) {
      if (!accumulatedCategoryOverviews[indicatorCategory.Category]) {
        accumulatedCategoryOverviews[indicatorCategory.Category] = {
          category: indicatorCategory.Category,
          maxRating: 0,
          verdict: "",
          indicators: [],
        };
      }
      for (let indicator of indicatorCategory.Indicators) {
        accumulatedCategoryOverviews[
          indicatorCategory.Category
        ].indicators.push({
          description: indicator.Description,
          extraInfo: indicator.ExtraInfo,
          item: indicator.Item,
          rating: indicator.Rating,
          verdict: getVerdictByRating(indicator.Rating),
        });
        accumulatedCategoryOverviews[indicatorCategory.Category].maxRating =
          Math.max(
            indicator.Rating,
            accumulatedCategoryOverviews[indicatorCategory.Category].maxRating
          );
      }
      Object.values(accumulatedCategoryOverviews).forEach(
        (categoryOverview) =>
          (categoryOverview.verdict = getVerdictByRating(
            categoryOverview.maxRating
          ))
      );
      // TODO: Consider some sort of deduplication here
    }
  }

  for (let cat of Object.values(accumulatedCategoryOverviews)) {
    let seen = new Set<string>();

    cat.indicators = cat.indicators
      .filter((ind) => {
        let key = `${ind.description}:${ind.item}:${ind.extraInfo || ""}:${
          ind.rating
        }`;
        if (seen.has(key)) {
          return false;
        }
        seen.add(key);
        return true;
      })
      .sort((a, b) => b.rating - a.rating);
  }

  return Object.values(accumulatedCategoryOverviews).sort(
    (a, b) => b.maxRating - a.maxRating
  );
}

export function extractFileNameFromFullPath(fileAnalysisData: any): string {
  // TODO: Just use the file name from the uploaded object
  const fileNameSplit = fileAnalysisData.FileName.split("\\");
  return fileNameSplit[fileNameSplit.length - 1];
}
